const endpoint = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.IMPERSONATE)

export const apiImpersonated = {
	goToImpersonate: async (id: number | string) => {
		try {
			await apiCommon<Promise<void>>(endpoint, {
				method: 'POST',
				body: { client_id: String(id) },
			})
		} catch (e) {
			console.error(e)
		}
	},
}
